import React from "react";

export const ModyoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 62 40"
      fill="none"
    >
      <path
        d="M59.011 7.90451C56.6033 2.53758 50.6767 -0.0842029 45.46 1.73562C52.2818 5.09767 56.7268 11.8834 56.7268 20.0572C56.7268 20.2423 56.7268 20.4274 56.7268 20.5816C59.9679 17.4663 61.0483 12.4078 59.011 7.90451Z"
        fill="currentColor"
      />
      <path
        d="M5.11491 15.6464C5.11491 14.7519 4.62102 14.3201 3.78759 14.3201H1.37988V7.84272H8.41778C11.1342 7.84272 12.4306 9.10735 12.4306 11.2665V12.1609C12.4306 12.8087 12.3689 13.4873 12.3689 13.4873H12.4924C13.9432 10.4953 17.6164 7.1333 22.401 7.1333C27.0312 7.1333 30.0254 9.29241 31.3527 13.4256H31.4762C33.1122 10.1252 37.0633 7.1333 41.9404 7.1333C48.2992 7.1333 51.9725 10.7421 51.9725 18.7925V30.7293C51.9725 31.5621 52.4664 32.0556 53.2998 32.0556H54.442V38.4713H48.4536C45.5828 38.4713 44.379 37.2683 44.379 34.3998V20.2113C44.379 16.7259 43.7308 14.0733 40.1809 14.0733C36.3842 14.0733 33.6987 17.2503 32.8344 21.1058C32.4639 22.3088 32.3405 23.5734 32.3405 25.0231V38.4713H24.7161V20.2113C24.7161 16.911 24.2222 14.0733 20.5798 14.0733C16.7213 14.0733 14.1592 17.2503 13.2023 21.1675C12.8936 22.3705 12.7084 23.6351 12.7084 25.0231V38.4713H5.11491V15.6464Z"
        fill="currentColor"
      />
    </svg>
  );
};
